export const FeedbackAllowedRoles = new Set([
  "GeneralAttorney",
  "AttorneyGeneral",
  "LRDIFUDDirector",
  "LegalResearchProsecutor",
  "LegalResearchCoordinator",
  "LegalTranslationCordinator",
  "LegalTranslationProsecutor",
  "ImpAwarenessProsecutor",
]);
export const SIDEBAR_ROUTES = [
  "/conduct-legal-research",
  "/legislative-drafting",
  "/legal-advisory",
  "/sector-directives",
  "/registering-directives",
  "/legal-translation",
  "/law-implementation",
  "/legal-awareness-creation",
  "/legal-training-provision",
  "/legal-training-provision-zone",
  "/legal-awareness-creation-zone",
  // "/researchs",
  "/stakeholders",
  "/main-task",
  "/reports",
  "/", // dashboard
];
export const shouldShowSidebar = (pathname: string): boolean => {
  return SIDEBAR_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(route + "/")
  );
};
export const REGISTRAL_ROLE_CONDUCT_RESEARCH_TABS = [
  "External Request",
  "Archived",
  "Internal Request",
  // "New Request",
];

export const STAKEHOLDER_ROLE_CONDUCT_RESEARCH_TABS = [
  "Legal Research Request",
  "Committee Request",
];

export const OAGB_MANAGEMENT_HEAD_ROLE_CONDUCT_RESEARCH_TABS = [
  "External Request",
  "Internal Request",
  // "New Request",
];

export const LEGAL_RESEARCH_PROSECUTOR_ROLE_CONDUCT_RESEARCH_TABS = [
  "External Request",
  "Internal Request",
  "Proposal Submission",
];

export const LEGAL_RESEARCH_COORDINATOR_ROLE_CONDUCT_RESEARCH_TABS = [
  "External Request",
  "Internal Request",
  // "Internal Request Topics",
  "Committee Request",
  // "New Request",
  // "Scheduled Presentation",
];

export const LRDI_FUD_DIRECTOR_ROLE_CONDUCT_RESEARCH_TABS = [
  "External Request",
  "Internal Request",
  "New Request",
];

export const LEGAL_RESEARCH_PROSECUTOR_TABS = [
  "Proposal Document",
  "Legal Research",
];

export const LEGAL_RESEARCH_PROSECUTOR_TAB = ["Proposal Document"];

export const LEGAL_RESEARCH_REGISTRAR_TABS = ["Research Finding"];

export const REGIONS = ["Region 1", "Region 2", "Region 3"];
export const ZONES = ["Zone 1", "Zone 2", "Zone 3"];
export const WOREDAS = ["Woreda 1", "Woreda 2", "Woreda 3"];
export const KEBELES = ["Kebele 1", "Kebele 2", "Kebele 3"];

export const LEGAL_RESEARCH_REQUEST_TYPES = [
  { label: "New Legislation", value: "new_legislation" },
  {
    label: "Amendment of Existing Legislation",
    value: "amend_existing",
  },
  {
    label: "Establishing New Business Process",
    value: "new_business_process",
  },
  { label: "Existing Legal Gaps", value: "legal_gaps" },
];

export const LEGAL_RESEARCH_REQUEST_STATUS = {
  received: { label: "Received", value: "received" },
  pending: { label: "Pending", value: "pending" },
  title_requested: { label: "Topic Requested", value: "title_requested" },
  title_approved: { label: "Topic Approved", value: "title_approved" },
  title_revision: { label: "Title Revision", value: "title_revision" },
  title_accepted: { label: "Topic Accepted", value: "topic_accepted" },
  title_presentation: {
    label: "Topic Presentation",
    value: "topic_presentation",
  },
  topic_approved: { label: "Topic Approved", value: "topic_approved" },
  proposal_requested: { label: "Under Revision", value: "proposal_requested" },
  proposal_underway: { label: "Proposal Underway", value: "proposal_underway" },
  proposal_approved: { label: "Proposal Approved", value: "proposal_approved" },
  proposal_submitted: { label: "Proposal Submitted", value: "proposal_submitted" },
  proposal_rejected: { label: "Proposal Rejected", value: "proposal_rejected" },
  proposal_revision: {
    label: "Revision Requested",
    value: "proposal_revision",
  },
  proposal_updated: { label: "Revision Updated", value: "proposal_updated" },
  proposal_presentation_feedback_submitted: {
    label: "Proposal Presentation Feedback Submitted",
    value: "proposal_presentation_feedback_submitted",
  },
  responded: { label: "Responded", value: "responded" }, // FOR WHEN OAGB HEAD RESPONDS TO STAKE HOLDER
  research_underway: { label: "Research Underway", value: "research_underway" },
  proposal_update: { label: "Proposal - Feedback", value: "proposal_update" },
  draft_submitted: { label: "Draft - Updated", value: "draft_submitted" },
  draft_rejected: { label: "Draft Rejected", value: "draft_rejected" },
  draft_approved: { label: "Awaiting approval", value: "draft_approved" },
  draft_revision: { label: "Draft Revision", value: "draft_revision" },
  research_committee_acceptd: {
    label: "ACCEPTED",
    value: "research committee acceptd",
  },
  research_committee_respondbacked: {
    label: "Responded Back",
    value: "research committee respondbacked",
  },
  research_committee_underway: {
    label: "UNDERWAY",
    value: "research committee underway",
  },
  research_committee_closed: {
    label: "CLOSED",
    value: "research committee closed",
  },
  completed: { label: "Completed", value: "completed" },
  sent_to_registrar: { label: "Sent To Registrar", value: "sent_to_registrar" },
  not_forwarded: {
    label: "Not Forwarded",
    value: "not_forwarded",
  },
  submitted: {
    label: "Submitted",
    value: "submitted",
  },
  forwarded_to_head: {
    label: "Forwarded to Head",
    value: "forwarded_to_head",
  },
  forwarded_to_management: {
    label: "Forwarded to Management",
    value: "forwarded_to_management",
  },
  forwarded_to_director: {
    label: "Forwarded to Director",
    value: "forwarded_to_director",
  },
  forwarded_to_coordinator: {
    label: "Forward To Director/Cordinator",
    value: "forwarded_to_coordinator",
  },
  assigned_to_prosecutor: {
    label: "Assigned to Prosecutor",
    value: "assigned_to_prosecutor",
  },
};

export const LEGISLATIVE_DRAFTING_REQUEST_STATUS = {
  submitted: { label: "Submitted by Stakeholder", value: "Submitted" },
  cafffee_aproval: { label: "Caffee Approval", value: "cafffee_aproval" },
  head_remark_submitted: {
    label: "Submitted",
    value: "head_remark_submitted",
  },
  director_remark_submitted: {
    label: "Submitted",
    value: "director_remark_submitted",
  },
  coordinator_remark_submitted: {
    label: "Submitted",
    value: "coordinator_remark_submitted",
  },
  oral_instruction_logged: {
    label: "Oral Instruction Logged",
    value: "oral_instruction_logged",
  },
  under_review: { label: "Under Review", value: "Under review" },

  draft_approved: { label: "Draft Approved", value: "Draft Approved" },
  draft_submitted: { label: "Draft Submitted", value: "draft_submitted" },
  draft_responded: { label: "Draft Responded", value: "draft_responded" },
  draft_non_ensential: {
    label: "Draft Non Essential",
    value: "draft_non_ensential",
  },

  letter_refnum_submitted: {
    label: "Letter Refnum Submitted",
    value: "letter_refnum_submitted",
  },
  public_and_amended_file_submitted: {
    label: "Public And Amended File Submitted",
    value: "public_and_amended_file_submitted",
  },
  audit_submitted: { label: "Audit Submitted", value: "audit_submitted" },
  audit_responded: { label: "Audit Responded", value: "audit_responded" },

  waiting_for_additional_info: {
    label: "Waiting for Additional Information",
    value: "Waiting for Additional Information",
  },
  additional_info_responded: {
    label: "Additional Info Responded",
    value: "additional_info_responded",
  },
  additional_info_submitted: {
    label: "Additional Info Submitted",
    value: "additional_info_submitted",
  },

  back_to_director: { label: "Back to Director", value: "Back to Director" },
  back_to_coordinator: {
    label: "Back to Coordinator",
    value: "Back to Coordinator",
  },
  back_to_head: { label: "Back to Head", value: "Back to Head" },
  updated_instruction_submitted: {
    label: "Updated Instruction Submitted",
    value: "updated_instruction_submitted",
  },
  finalized_by_prosecutor: {
    label: "Finalized by Prosecutor",
    value: "finalized_by_prosecutor",
  },
  final_approval: { label: "Final Approval", value: "Final Approval" },
  reviewed_by_coordinator: {
    label: "Reviewed by Coordinator",
    value: "reviewed_by_coordinator",
  },
  reviewed_by_director: {
    label: "Reviewed by Director",
    value: "reviewed_by_director",
  },
  approved_by_head: { label: "Approved by Head", value: "Approved by Head" },
  follow_up: { label: "Follow-up", value: "follow_up" },
  published: { label: "Published", value: "Published" },
  public_feedback: { label: "Public Feedback", value: "allow_public_feedback" },

  not_forwarded: { label: "Not Forwarded", value: "not_forwarded" },
  forwarded_to_head: { label: "Forwarded to Head", value: "forwarded_to_head" },
  forwarded_to_director: {
    label: "Forwarded to Director",
    value: "forwarded_to_director",
  },
  forwarded_to_coordinator: {
    label: "Forward To Director/Cordinator",
    value: "forwarded_to_coordinator",
  },
  assigned_to_prosecutor: {
    label: "Assigned to Prosecutor",
    value: "assigned_to_prosecutor",
  },
  forwarded_to_registrar: {
    label: "Forwarded to Registrar",
    value: "sent_to_registrar",
  },
  sent_to_zone: {
    label: "Sent To Zonal Office",
    value: "sent_to_zonal_office",
  },
};

export const LEGAL_ADVISORY_REQUEST_STATUS = {
  submitted: { label: "Submitted by Stakeholder", value: "Submitted" },
  oral_instruction_logged: {
    label: "Oral Instruction Logged",
    value: "oral_instruction_logged",
  },
  under_review: { label: "Under Analysis", value: "Under Analysis" },
  head_remark_submitted: {
    label: "Head Remark Submitted",
    value: "head_remark_submitted",
  },
  director_remark_submitted: {
    label: "Director Remark Submitted",
    value: "director_remark_submitted",
  },
  coordinator_remark_submitted: {
    label: "Coordinator Remark Submitted",
    value: "coordinator_remark_submitted",
  },

  draft_approved: { label: "Approved by LDCCM", value: "Approved by LDCCM" },
  draft_submitted: { label: "Draft Prepared", value: "Draft Prepared" },
  draft_responded: { label: "Draft Responded", value: "draft_responded" },

  letter_refnum_submitted: {
    label: "Archived in OAGB Records",
    value: "Archived",
  },
  public_and_amended_file_submitted: {
    label: "Public And Amended File Submitted",
    value: "public_and_amended_file_submitted",
  },
  audit_submitted: { label: "Audit Submitted", value: "audit_submitted" },
  audit_responded: { label: "Audit Responded", value: "audit_responded" },

  waiting_for_additional_info: {
    label: "Waiting for Additional Information",
    value: "Waiting for Additional Information",
  },
  additional_info_responded: {
    label: "Additional Info Responded",
    value: "additional_info_responded",
  },
  additional_info_submitted: {
    label: "Additional Info Submitted",
    value: "additional_info_submitted",
  },

  back_to_director: { label: "Back to Director", value: "Back to Director" },
  back_to_coordinator: {
    label: "Back to Coordinator",
    value: "Back to Coordinator",
  },
  back_to_head: { label: "Back to Head", value: "Back to Head" },
  updated_instruction_submitted: {
    label: "Updated Instruction Submitted",
    value: "updated_instruction_submitted",
  },
  finalized_by_prosecutor: {
    label: "Finalized by Prosecutor",
    value: "finalized_by_prosecutor",
  },
  final_approval: { label: "Final Approval", value: "Final Approval" },
  reviewed_by_coordinator: {
    label: "Reviewed by Coordinator",
    value: "reviewed_by_coordinator",
  },
  reviewed_by_director: {
    label: "Reviewed by Director",
    value: "reviewed_by_director",
  },
  approved_by_head: { label: "Approved by Head", value: "Approved by Head" },
  follow_up: { label: "Follow-up", value: "follow_up" },
  published: { label: "Published", value: "Published" },

  not_forwarded: { label: "Not Forwarded", value: "not_forwarded" },
  forwarded_to_head: { label: "Forwarded to Head", value: "forwarded_to_head" },
  forwarded_to_director: {
    label: "Forwarded to Director",
    value: "forwarded_to_director",
  },
  forwarded_to_coordinator: {
    label: "Forward To Director/Cordinator",
    value: "forwarded_to_coordinator",
  },
  assigned_to_prosecutor: {
    label: "Assigned to Prosecutor",
    value: "assigned_to_prosecutor",
  },
  forwarded_to_registrar: {
    label: "Forwarded to Registrar",
    value: "sent_to_registrar",
  },
};

export const SECTOR_DIRECTIVES_REQUEST_STATUS = {
  submitted: { label: "Submitted by Stakeholder", value: "Submitted" },
  oral_instruction_logged: {
    label: "Oral Instruction Logged",
    value: "oral_instruction_logged",
  },
  under_review: { label: "Under Analysis", value: "Under Analysis" },

  draft_approved: { label: "Approved by Head", value: "Approved by Head" },
  draft_submitted: { label: "Draft Prepared", value: "Draft Prepared" },
  draft_responded: { label: "Draft Responded", value: "draft_responded" },

  letter_refnum_submitted: {
    label: "Archived in OAGB Records",
    value: "archived",
  },
  public_and_amended_file_submitted: {
    label: "Public And Amended File Submitted",
    value: "public_and_amended_file_submitted",
  },
  audit_submitted: { label: "Audit Submitted", value: "audit_submitted" },
  audit_responded: { label: "Audit Responded", value: "audit_responded" },

  waiting_for_additional_info: {
    label: "Waiting for Additional Information",
    value: "Waiting for Additional Information",
  },
  additional_info_responded: {
    label: "Additional Info Responded",
    value: "additional_info_responded",
  },
  additional_info_submitted: {
    label: "Additional Info Submitted",
    value: "additional_info_submitted",
  },

  back_to_director: { label: "Back to Director", value: "Back to Director" },
  back_to_coordinator: {
    label: "Back to Coordinator",
    value: "Back to Coordinator",
  },
  back_to_head: { label: "Back to Head", value: "Back to Head" },
  updated_instruction_submitted: {
    label: "Updated Instruction Submitted",
    value: "updated_instruction_submitted",
  },
  finalized_by_prosecutor: {
    label: "Finalized by Prosecutor",
    value: "finalized_by_prosecutor",
  },
  final_approval: { label: "Final Approval", value: "Final Approval" },
  reviewed_by_coordinator: {
    label: "Reviewed by Coordinator",
    value: "reviewed_by_coordinator",
  },
  reviewed_by_director: {
    label: "Reviewed by Director",
    value: "reviewed_by_director",
  },
  approved_by_head: { label: "Approved by Head", value: "Approved by Head" },
  follow_up: { label: "Follow-up", value: "follow_up" },
  published: { label: "Published", value: "Published" },

  not_forwarded: { label: "Not Forwarded", value: "not_forwarded" },
  forwarded_to_head: { label: "Forwarded to Head", value: "forwarded_to_head" },
  forwarded_to_director: {
    label: "Forwarded to Director",
    value: "forwarded_to_director",
  },
  forwarded_to_coordinator: {
    label: "Forward To Director/Cordinator",
    value: "forwarded_to_coordinator",
  },
  assigned_to_prosecutor: {
    label: "Assigned to Prosecutor",
    value: "assigned_to_prosecutor",
  },
  forwarded_to_registrar: {
    label: "Forwarded to Registrar",
    value: "sent_to_registrar",
  },
  additional_info_requested: {
    label: "Additional Info Requested",
    value: "additional_info_requested",
  },
};

export const LAW_IMPLEMENTATION_REQUEST_STATUS = {
  pending: { label: "Pending", value: "pending" },
  proposal_submitted: {
    label: "Enforcement Analysis Proposal Submitted",
    value: "proposal_submitted",
  },
  proposal_responded: {
    label: "Enforcement Analysis Proposal Responded",
    value: "proposal_responded",
  },
  team_appointed: { label: "Team Appointed", value: "team_appointed" },
  identification_complete: {
    label: "Identification Complete",
    value: "identification_complete",
  },
  identification_in_progress: {
   label: "Audit Targets Identification",
   value: "identification_in_progress",
  },
  evidence_collected: {
    label: "Evidence Collected",
    value: "evidence_collected",
  },
  audit_in_progress: { label: "Audit In Progress", value: "audit_in_progress" },
  audit_completed: { label: "Audit Complete", value: "audit_completed" },
  audit_responded: { label: "Audit Responded", value: "audit_responded" },
  finalization_complete: {
    label: "Finalization Complete",
    value: "finalization_complete",
  },
  letter_refnum_submitted: {
    label: "Reference Number submitted",
    value: "registrar_number_submitted",
  },
};

export const LEGAL_AWAERENESS_REQUEST_STATUS = {
  pending: { label: "Pending", value: "pending" },
  summary_submitted: { label: "Summary Submited", value: "summary_submitted" },
  summary_approved: { label: "Summary Approved", value: "summary_approved" },
  session_scheduled: { label: "Session Scheduled", value: "session_scheduled" },
  outcome_submitted: { label: "Outcome Submitted", value: "outcome_submitted" },
  identification_in_progress: {
    label: "Identification In Progress",
    value: "identification_in_progress",
  },
  audit_in_progress: { label: "Audit In Progress", value: "audit_in_progress" },
  audit_completed: { label: "Audit Complete", value: "audit_completed" },
  finalization_complete: {
    label: "Finalization Complete",
    value: "finalization_complete",
  },
};

export const LEGAL_TRAINING_PROVISION_REQUEST_STATUS = {
  submitted: {
    label: "Submitted by Stakeholder",
    value: "traning_request_submitted",
  },
  submitted_internal: {
    label: "Submitted Internally",
    value: "internal_traning_request_submitted",
  },
  oral_instruction_logged: {
    label: "Oral Instruction Logged",
    value: "oral_instruction_logged",
  },
  under_review: { label: "Under Analysis", value: "under_review" },

  team_assigned: { label: "Team Assigned", value: "team_assigned" },
  training_manual_submitted: {
    label: "Traning Manual Submitted",
    value: "training_manual_submitted",
  },
  training_manual_approved: {
    label: "Traning Manual Approved",
    value: "approved",
  },

  letter_refnum_submitted: {
    label: "Letter Reference Number Submitted",
    value: "letter_ref_no_submitted",
  },
  training_scheduled: {
    label: "Training Scheduled",
    value: "training_scheduled",
  },
  final: { label: "Final", value: "final" },
  audit_responded: { label: "Audit Responded", value: "audit_responded" },

  waiting_for_additional_info: {
    label: "Waiting for Additional Information",
    value: "Waiting for Additional Information",
  },
  additional_info_responded: {
    label: "Additional Info Responded",
    value: "additional_info_responded",
  },
  additional_info_submitted: {
    label: "Additional Info Submitted",
    value: "additional_info_submitted",
  },

  back_to_director: { label: "Back to Director", value: "Back to Director" },
  back_to_coordinator: {
    label: "Back to Coordinator",
    value: "Back to Coordinator",
  },
  back_to_head: { label: "Back to Head", value: "Back to Head" },
  updated_instruction_submitted: {
    label: "Updated Instruction Submitted",
    value: "updated_instruction_submitted",
  },
  finalized_by_prosecutor: {
    label: "Finalized by Prosecutor",
    value: "finalized_by_prosecutor",
  },
  final_approval: { label: "Final Approval", value: "Final Approval" },
  reviewed_by_coordinator: {
    label: "Reviewed by Coordinator",
    value: "reviewed_by_coordinator",
  },
  reviewed_by_director: {
    label: "Reviewed by Director",
    value: "reviewed_by_director",
  },
  approved_by_head: { label: "Approved by Head", value: "Approved by Head" },
  follow_up: { label: "Follow-up", value: "follow_up" },
  published: { label: "Published", value: "Published" },

  not_forwarded: { label: "Not Forwarded", value: "not_forwarded" },
  forwarded_to_head: { label: "Forwarded to Head", value: "forwarded_to_head" },
  forwarded_to_director: {
    label: "Forwarded to Director",
    value: "forwarded_to_director",
  },
  forwarded_to_coordinator: {
    label: "Forward To Director/Cordinator",
    value: "forwarded_to_coordinator",
  },
  assigned_to_prosecutor: {
    label: "Assigned to Prosecutor",
    value: "assigned_to_prosecutor",
  },
  forwarded_to_registrar: {
    label: "Forwarded to Registrar",
    value: "sent_to_registrar",
  },
};

export interface TokenPayload {
  sub: string;
  exp: number;
  email?: string;
  first_name?: string;
  last_name?: string;
  organization?: any;
  // add other claims your backend sends
}
